import React from 'react';
import { CopyValueToClipboard, Separator } from 'features/nekst-widgets';
import { SimpleBlock, LoadingAnimation, Header5, Text } from 'ui-builder';
import { ICalLinks } from 'nekst-api';
import styles from './CalendarLinksBlockLayout.module.scss';

export interface CalendarLinksBlockLayoutProps {
  isLoading: boolean;
  data: ICalLinks | null;
}

export function CalendarLinksBlockLayout(props: CalendarLinksBlockLayoutProps) {
  if (props.isLoading) {
    return <LoadingAnimation />;
  }

  if (!props.data) {
    return null;
  }

  const links = props.data;

  return (
    <SimpleBlock>
      <Header5 className={styles.header}>CALENDAR LINKS</Header5>
      <Separator />
      <Text>
        Share a custom link that includes tasks for all Active Transactions in which this contact is associated.
      </Text>
      <Separator />

      <div className={styles.linkRow}>
        <a
          href={links.keyDates}
          className={styles.linkLabel}
        >
          Key Date Link
        </a>
        <CopyValueToClipboard text={links.keyDates} />
      </div>

      <div className={styles.linkRow}>
        <a
          href={links.roadmap}
          className={styles.linkLabel}
        >
          Roadmap Link
        </a>
        <CopyValueToClipboard text={links.roadmap} />
      </div>
    </SimpleBlock>
  );
}
